import React, { useRef, memo } from 'react';
import upperFirst from 'lodash/upperFirst';

import useSidePaddingsOnHorizontalScroll from 'hooks/useSidePaddingsOnHorizontalScroll';
import { TGame } from 'types';
import './styles.scss';

interface IGameTags {
  game: TGame;
}

const GameTags: React.FC<IGameTags> = ({ game }) => {
  const ref = useRef<HTMLDivElement>(null);

  useSidePaddingsOnHorizontalScroll(ref);

  return (
    <div className="flex scrollable-gutters overflow-x-scroll mb2 no-scroll" ref={ref}>
      {game.tags.map((tag: string) => (
        <div key={tag} className="tag mr1">{upperFirst(tag.toLowerCase())}</div>
      ))}
    </div>
  );
};

export default memo(GameTags);
